

/*eslint-disable*/
import React, { useState, useEffect, useRef } from 'react';
import { Tabs, Table, Button, Form, Input, Spin, Space, Select } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, HomeOutlined, SearchOutlined, RedoOutlined, PlusCircleOutlined, EditOutlined, DeleteOutlined, EyeOutlined, CopyOutlined } from '@ant-design/icons';
import Message from '../../component/message/message'; // 提示信息弹窗  
import PopupFrame from '../../component/popupFrame/popupFrame';
import Audit from '../../component/audit/audit';//审核彈框
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import trans from './translation';
import moment from 'moment';//日期格式化导包
import './programmeWpaTemplate.css';

const { TabPane } = Tabs;
const { TextArea } = Input;
const ProgrammeWpaTemplate = (props) => {
    const messageRef = useRef();
    const [form] = Form.useForm();
    const [tabIndex, setTabIndex] = useState("1");
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [checkboxState, setCheckboxState] = useState([]);
    const [flag, setFlag] = useState("add");
    const [isAudit, setIsAudit] = useState(false);
    const [isDeleteFrame, setIsDeleteFrame] = useState(false);
    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [searchModel, setSearchModel] = useState({});
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [auditModel, setAuditModel] = useState({});
    const [isLoad, setIsLoad] = useState(false);
    const [spinInfo, setSpinInfo] = useState("");
    const [isLeave, setIsLeave] = useState(false);
    const [cohortList, setCohortList] = useState([]);
    const [deleteTipText, setDeleteTipText] = useState("");

    useEffect(() => {
        searchCohortList()
        search(pageSize, 1, "N");
    }, []);

    const searchCohortList = () => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        Base.callBackApi("cohortProg/searchCohortList").then((data) => {
            if ("SUCCESS" === data.msg) {
                let list = data.object ?? []
                setCohortList(list)
            } else {
                errFrameShow("error", data.msg);
            }
        })
    }

    const search = (pageSizeNew, currentPageNew, flag, isShowMsg) => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        messageShowHandler();  // 清除提示信息
        let model = {};
        if ("Y" === flag) {     // 翻页
            model = oldSearchModel;
        } else {
            model = searchModel;
        }
        model.page = currentPageNew;
        model.startRow = (currentPageNew - 1) * pageSizeNew;
        model.pageSize = pageSizeNew;
        setIsLoad(true);
        setSpinInfo(trans.beQuerying[Config.backLang]);
        Base.callBackApi("programmeWpaTemplate/search", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!data?.object?.list && isShowMsg) {
                    errFrameShow("info", trans.noneDate[Config.backLang]);
                }
                if ("N" === flag) {
                    setOldSearchModel(JSON.parse(JSON.stringify(model)));
                }
                setTablesCount(data?.object?.total ?? 0);
                setTables(data?.object?.list ?? []);
                setCurrent(currentPageNew);
                setPageSize(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));

    }

    const searchChange = (key, value) => {
        messageShowHandler();
        setSearchModel(model => {
            return { ...model, ...{ [key]: value } };
        });
    }

    const reset = () => {
        messageShowHandler();
        clearSelect();
        setSearchModel({});
        setOldSearchModel({});
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
    }

    // Tab页切换
    const handleSelect = (key) => {
        if (key) {
            if (key === "2") {
                if (checkboxState.length === 1 && Config.funcInfo.canUpdate === "Y") {
                    edit();
                } else if (Config.funcInfo.canInsert === "Y") {
                    add();
                }
            } else if (tabIndex !== "1") {
                setTabIndex("1");
                search(pageSize, current, "Y");
            }
        }
    }

    const add = () => {
        messageShowHandler();
        initForm({});
        setFlag("add");
        setTabIndex("2");
    }

    const update = (model, e) => {
        messageShowHandler();
        searchById(model.wpaQuestionsId);
        setFlag("edit");
        setTabIndex("2");
    }

    const edit = () => {
    }

    const initForm = (model = {}) => {
        form.resetFields();
        form.setFieldsValue({
            cohortId: model.cohortId ?? "",
            wpaQuestion1: model.wpaQuestion1 ?? "",
            wpaQuestion2: model.wpaQuestion2 ?? "",
            wpaQuestion3: model.wpaQuestion3 ?? "",
            wpaQuestion4: model.wpaQuestion4 ?? "",
            wpaQuestion5: model.wpaQuestion5 ?? "",
            wpaQuestion6: model.wpaQuestion6 ?? "",
            wpaQuestion7: model.wpaQuestion7 ?? "",
            wpaQuestion8: model.wpaQuestion8 ?? "",
            wpaQuestion1Sc: model.wpaQuestion1Sc ?? "",
            wpaQuestion2Sc: model.wpaQuestion2Sc ?? "",
            wpaQuestion3Sc: model.wpaQuestion3Sc ?? "",
            wpaQuestion4Sc: model.wpaQuestion4Sc ?? "",
            wpaQuestion5Sc: model.wpaQuestion5Sc ?? "",
            wpaQuestion6Sc: model.wpaQuestion6Sc ?? "",
            wpaQuestion7Sc: model.wpaQuestion7Sc ?? "",
            wpaQuestion8Sc: model.wpaQuestion8Sc ?? "",
            wpaQuestion1Tc: model.wpaQuestion1Tc ?? "",
            wpaQuestion2Tc: model.wpaQuestion2Tc ?? "",
            wpaQuestion3Tc: model.wpaQuestion3Tc ?? "",
            wpaQuestion4Tc: model.wpaQuestion4Tc ?? "",
            wpaQuestion5Tc: model.wpaQuestion5Tc ?? "",
            wpaQuestion6Tc: model.wpaQuestion6Tc ?? "",
            wpaQuestion7Tc: model.wpaQuestion7Tc ?? "",
            wpaQuestion8Tc: model.wpaQuestion8Tc ?? "",
            IBoxContent: model.IBoxContent ?? "",
            IBoxContentSC: model.IBoxContentSC ?? "",
            IBoxContentTC: model.IBoxContentTC ?? "",
        });
    }

    const deleteFrameClose = (state) => {
        if (state) {
            deleteData();
        }
        clearSelect();
        setIsDeleteFrame(false);
    }

    const deleteData = () => {
        setIsLoad(true);
        setSpinInfo(trans.deleteData[Config.backLang]);
        let deleteModel = checkboxState[0];
        deleteModel.menuFuncId = Config.funcInfo.funcId;
        Base.callBackApi("programmeWpaTemplate/delete", deleteModel).then((data) => {
            if ("SUCCESS" === data.msg) {
                cancel();
                search(pageSize, current, "Y", false);
                errFrameShow("success", trans.deleteSuccess[Config.backLang]);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const audit = (model, e) => {
        messageShowHandler();//清空提示信息
        e.stopPropagation();
        setAuditModel(model);
        setIsAudit(true);
    }

    const auditCancel = () => {
        setIsAudit(false);
    }

    const onFinish = (values) => {
        messageShowHandler();
        setIsLoad(true);
        setSpinInfo(trans.dataBeSaving[Config.backLang])
        let url = "";
        if (flag === "add") {
            url = "programmeWpaTemplate/insert";
        } else {
            url = "programmeWpaTemplate/update"
            values.wpaQuestionsId = selectedRowKeys[0];
            values.lastUpdatedDate = checkboxState[0].lastUpdatedDate;
        }
        values.menuFuncId = Config.funcInfo.funcId;
        Base.callBackApi(url, values).then((data) => {
            if ("SUCCESS" === data.msg) {
                searchById(data.object)
                errFrameShow("success", trans.saveSuccess[Config.backLang]);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => {
            setIsLoad(false);
        });
    }

    const searchById = (wpaQuestionsId, flag = true) => {
        setIsLoad(true);
        Base.callBackApi("programmeWpaTemplate/searchById", wpaQuestionsId).then((data) => {
            if ("SUCCESS" === data.msg) {
                let model = data.object;
                if (flag) {
                    setFlag("edit");
                } else {
                    model.cohortId = '';
                }
                initForm(model);
                setCheckboxState([model]);
                setSelectedRowKeys([model.wpaQuestionsId]);
                
            } else {
                this.errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const cancel = () => {
        messageShowHandler();
        clearSelect();
        setTabIndex("1");
        search(pageSize, current, "Y");
    }

    const leaveFrameClose = (state) => {
        if (state) {
            cancel();
        }
        setIsLeave(false);
    }

    const deleteOne = (model, e) => {
        e.stopPropagation();
        setDeleteTipText("Cohort" + ":" + model.cohortYear + "")
        setCheckboxState([model])
        setIsDeleteFrame(true);
    }

    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew, "Y");
    }
    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1, "Y");
    }

    //清空列表选中
    const clearSelect = () => {
        setSelectedRowKeys([]);
        setCheckboxState([]);
    }

    // 生成提示信息
    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    // 清除提示信息
    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }
    
    const questionChange = (value, label1,label2) => {
        if (!value) {
            form.validateFields([label1,label2])
        }
    };

    const validateForm = (values,label) => {
        if(label === "wpaQuestion1" &&  (form.getFieldValue('wpaQuestion1Tc') || form.getFieldValue('wpaQuestion1Sc')) && !values ){
            return Promise.reject('English is required.');
        }
        if(label === "wpaQuestion1Tc" &&  (form.getFieldValue('wpaQuestion1') || form.getFieldValue('wpaQuestion1Sc')) && !values ){
            return Promise.reject('Traditional Chinese is required.');
        }
        if(label === "wpaQuestion1Sc" &&  (form.getFieldValue('wpaQuestion1') || form.getFieldValue('wpaQuestion1Tc')) && !values ){
            return Promise.reject('Simplified Chinese is required.');
        }

        if(label === "wpaQuestion2" &&  (form.getFieldValue('wpaQuestion2Tc') || form.getFieldValue('wpaQuestion2Sc')) && !values ){
            return Promise.reject('English is required.');
        }
        if(label === "wpaQuestion2Tc" &&  (form.getFieldValue('wpaQuestion2') || form.getFieldValue('wpaQuestion2Sc')) && !values ){
            return Promise.reject('Traditional Chinese is required.');
        }
        if(label === "wpaQuestion2Sc" &&  (form.getFieldValue('wpaQuestion2') || form.getFieldValue('wpaQuestion2Tc')) && !values ){
            return Promise.reject('Simplified Chinese is required.');
        }

        if(label === "wpaQuestion3" &&  (form.getFieldValue('wpaQuestion3Tc') || form.getFieldValue('wpaQuestion3Sc')) && !values ){
            return Promise.reject('English is required.');
        }
        if(label === "wpaQuestion3Tc" &&  (form.getFieldValue('wpaQuestion3') || form.getFieldValue('wpaQuestion3Sc')) && !values ){
            return Promise.reject('Traditional Chinese is required.');
        }
        if(label === "wpaQuestion3Sc" &&  (form.getFieldValue('wpaQuestion3') || form.getFieldValue('wpaQuestion3Tc')) && !values ){
            return Promise.reject('Simplified Chinese is required.');
        }

        if(label === "wpaQuestion4" &&  (form.getFieldValue('wpaQuestion4Tc') || form.getFieldValue('wpaQuestion4Sc')) && !values ){
            return Promise.reject('English is required.');
        }
        if(label === "wpaQuestion4Tc" &&  (form.getFieldValue('wpaQuestion4') || form.getFieldValue('wpaQuestion4Sc')) && !values ){
            return Promise.reject('Traditional Chinese is required.');
        }
        if(label === "wpaQuestion4Sc" &&  (form.getFieldValue('wpaQuestion4') || form.getFieldValue('wpaQuestion4Tc')) && !values ){
            return Promise.reject('Simplified Chinese is required.');
        }

        if(label === "wpaQuestion5" &&  (form.getFieldValue('wpaQuestion5Tc') || form.getFieldValue('wpaQuestion5Sc')) && !values ){
            return Promise.reject('English is required.');
        }
        if(label === "wpaQuestion5Tc" &&  (form.getFieldValue('wpaQuestion5') || form.getFieldValue('wpaQuestion5Sc')) && !values ){
            return Promise.reject('Traditional Chinese is required.');
        }
        if(label === "wpaQuestion5Sc" &&  (form.getFieldValue('wpaQuestion5') || form.getFieldValue('wpaQuestion5Tc')) && !values ){
            return Promise.reject('Simplified Chinese is required.');
        }

        if(label === "wpaQuestion6" &&  (form.getFieldValue('wpaQuestion6Tc') || form.getFieldValue('wpaQuestion6Sc')) && !values ){
            return Promise.reject('English is required.');
        }
        if(label === "wpaQuestion6Tc" &&  (form.getFieldValue('wpaQuestion6') || form.getFieldValue('wpaQuestion6Sc')) && !values ){
            return Promise.reject('Traditional Chinese is required.');
        }
        if(label === "wpaQuestion6Sc" &&  (form.getFieldValue('wpaQuestion6') || form.getFieldValue('wpaQuestion6Tc')) && !values ){
            return Promise.reject('Simplified Chinese is required.');
        }

        if(label === "wpaQuestion7" &&  (form.getFieldValue('wpaQuestion7Tc') || form.getFieldValue('wpaQuestion7Sc')) && !values ){
            return Promise.reject('English is required.');
        }
        if(label === "wpaQuestion7Tc" &&  (form.getFieldValue('wpaQuestion7') || form.getFieldValue('wpaQuestion7Sc')) && !values ){
            return Promise.reject('Traditional Chinese is required.');
        }
        if(label === "wpaQuestion7Sc" &&  (form.getFieldValue('wpaQuestion7') || form.getFieldValue('wpaQuestion7Tc')) && !values ){
            return Promise.reject('Simplified Chinese is required.');
        }

        if(label === "wpaQuestion8" &&  (form.getFieldValue('wpaQuestion8Tc') || form.getFieldValue('wpaQuestion8Sc')) && !values ){
            return Promise.reject('English is required.');
        }
        if(label === "wpaQuestion8Tc" &&  (form.getFieldValue('wpaQuestion8') || form.getFieldValue('wpaQuestion8Sc')) && !values ){
            return Promise.reject('Traditional Chinese is required.');
        }
        if(label === "wpaQuestion8Sc" &&  (form.getFieldValue('wpaQuestion8') || form.getFieldValue('wpaQuestion8Tc')) && !values ){
            return Promise.reject('Simplified Chinese is required.');
        }
        return Promise.resolve();
    };
    
    const duplicate = (model, e) => {
        e.stopPropagation();
        messageShowHandler()
        setFlag("add");
        setTabIndex("2");
        searchById(model.wpaQuestionsId, false);
    }

    /*eslint-disable*/
    const columns = [
        {
            title: 'Cohort',
            dataIndex: 'cohortYear',
            className: 'tableWidth40',
        },

        {
            title: "Last Update Date",
            dataIndex: 'lastUpdatedDate',
            className: 'tableWidth60',
            render: (text) => moment(text).format(Config.dateFormatALL)
        },
        {
            title: trans.controls[Config.backLang],
            dataIndex: '',
            className: ' sysControls',
            fixed: 'right',
            width: 300,
            render: (text, record) => <div className='operation'>
                <div className='sysUpdate' onClick={(e) => duplicate(record, e)} hidden={Config.funcInfo.canInsert === "N"}><CopyOutlined /> Duplicate</div>
                <div className='sysUpdate' onClick={(e) => update(record, e)} hidden={Config.funcInfo.canUpdate === "N"}><EditOutlined /> {trans.update[Config.backLang]}</div>
                <div className='sysDelete' onClick={(e) => deleteOne(record, e)} hidden={Config.funcInfo.canDelete === "N"}><DeleteOutlined /> {trans.delete[Config.backLang]}</div>
                <div className='sysLogs' onClick={(e) => audit(record, e)}><EyeOutlined /> {trans.audit[Config.backLang]}</div>
            </div>
        },
    ];

    return (
        <div id="container" className="template programmeWpaTemplate">
            <div className='breadcrumb'>
                <HomeOutlined /> / Admin / <span className='breadcrumbTitle'>{Config.funcInfo['funcName' + (Config.backLang === 'TC' ? 'Tc' : '')]}</span>
            </div>
            {/* 提示信息弹框 */}
            <Message ref={messageRef} />
            <div className='templateMain'>
                <Spin size="large" spinning={isLoad} tip={spinInfo}>
                    {/* 删除弹框 */}
                    {isDeleteFrame ? <PopupFrame close={deleteFrameClose} deleteTipText={deleteTipText} /> : null}
                    {isLeave ? <PopupFrame close={leaveFrameClose} type='leave' /> : null}
                    {/* 审核彈框 */}
                    <Audit visible={isAudit} auditModel={auditModel} close={auditCancel} />
                    <Tabs activeKey={tabIndex} onChange={(e) => handleSelect(e)}>
                        <TabPane key="1" tab={trans.list[Config.backLang]}>
                            <div className='sysSearchRow sysSearchBox'>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysTitle programmeWpaTemplateSerchTitle">{trans.cohortYear[Config.backLang]}</div>
                                        <div className="sysSerchInput">
                                            <Select className="sysSelect" placeholder={trans.cohortYear[Config.backLang]}
                                                value={searchModel.cohortId || ''}
                                                onChange={(e) => searchChange('cohortId', e)}
                                            >
                                                <Option value=''></Option>
                                                {cohortList.map((item) => <Option key={item.cohortId} value={item.cohortId}>{item.cohortYear}</Option>)}
                                            </Select>
                                        </div>
                                    </div>
                                    <div className='sysSearchButton'>
                                        <Button className="sysBtn btnBlue" type="primary" onClick={() => search(pageSize, 1, "N", true)} hidden={Config.funcInfo.canSelect === "N"} icon={<SearchOutlined />}>{trans.search[Config.backLang]}</Button>
                                        <Button className="sysBtn" onClick={reset} icon={<RedoOutlined />}>{trans.reset[Config.backLang]}</Button>
                                    </div>
                                </div>
                            </div>
                            <div className="sysLineEight"></div>
                            <Space size={[5, 5]} wrap className="sysButtonRelative">
                                <Button type="primary" className="sysBtn btnBlue" onClick={add} hidden={Config.funcInfo.canInsert === "N"} icon={<PlusCircleOutlined />}>{trans.add[Config.backLang]}</Button>
                            </Space>
                            <div className="sysTable" id="tableOne">
                                <Table
                                    scroll={{ x: 600 }}
                                    rowKey="wpaQuestionsId" //Key值
                                    columns={columns} //列名
                                    dataSource={tables} //数据
                                    pagination={{  //分页
                                        showSizeChanger: true,                //是否显示可以设置几条一页的选项
                                        onChange: onChange,                  //上页下页或者跳页方法
                                        onShowSizeChange: onShowSizeChange,          //每页显示条数方法
                                        total: tablesCount,        //总共多少条数据
                                        current: current,       //当前页
                                        pageSize: pageSize,  //每页显示多少条数据
                                        defaultCurrent: 1,          //默认当前页为1
                                        size: "small"
                                    }}
                                />
                            </div>
                        </TabPane>
                        <TabPane key="2" tab={trans.generalWpaTemplate[Config.backLang]} forceRender={true}>
                            <Form form={form} onFinish={onFinish}>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam  mustFill">Cohort</div>
                                        <div className="sysInput ">
                                            <Form.Item
                                                name="cohortId"
                                                rules={[
                                                    { required: true, message: trans.cohortYearNoIsNull[Config.backLang] },
                                                ]}
                                            >
                                                <Select className="sysSelect" placeholder={trans.cohortYear[Config.backLang]} disabled={flag === 'view'}>
                                                    <Option value=''></Option>
                                                    {cohortList.map((item) => <Option key={item.cohortId} value={item.cohortId}>{item.cohortYear}</Option>)}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div>
                                            <div className="sysParam  mustFill">{trans.programmeUniqueQuestion1[Config.backLang]}</div>
                                        </div>
                                        <div className='wpaQuestionRow'>
                                            <div className='wpaQuestionBox'>
                                                <div className='wpaQuestionTitle'>English</div>
                                                <div className="sysInput">
                                                    <Form.Item
                                                        name="wpaQuestion1"
                                                        rules={[
                                                            {
                                                                required: true, message: 'English is required.'
                                                            },
                                                            {
                                                                validator: (rule, value) => validateForm(value,"wpaQuestion1")
                                                            },
                                                        ]}
                                                    >
                                                        <Input type="text" maxLength={255} onChange={(e) => questionChange(e.target.value, "wpaQuestion1Tc","wpaQuestion1Sc")} />
                                                    </Form.Item>
                                                </div>
                                            </div>
                                            <div className='wpaQuestionBox'>
                                                <div className='wpaQuestionTitle'>Traditional Chinese</div>
                                                <div className="sysInput">
                                                    <Form.Item
                                                        name="wpaQuestion1Tc"
                                                        rules={[
                                                            {
                                                                required: false,
                                                                validator: (rule, value) => validateForm(value,"wpaQuestion1Tc")
                                                            },
                                                        ]}
                                                    >
                                                        <Input type="text" maxLength={255} onChange={(e) => questionChange(e.target.value, "wpaQuestion1","wpaQuestion1Sc")} />
                                                    </Form.Item>
                                                </div>
                                            </div>
                                            <div className='wpaQuestionBox'>
                                                <div className='wpaQuestionTitle'>Simplified Chinese</div>
                                                <div className="sysInput">
                                                    <Form.Item
                                                        name="wpaQuestion1Sc"
                                                        rules={[
                                                            {
                                                                required: false,
                                                                validator: (rule, value) => validateForm(value,"wpaQuestion1Sc")
                                                            },
                                                        ]}
                                                    >
                                                        <Input type="text" maxLength={255} onChange={(e) => questionChange(e.target.value, "wpaQuestion1","wpaQuestion1Tc")} />
                                                    </Form.Item>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div>
                                            <div className="sysParam  mustFill">{trans.programmeUniqueQuestion2[Config.backLang]}</div>
                                        </div>
                                        <div className='wpaQuestionRow'>
                                            <div className='wpaQuestionBox'>
                                                <div className='wpaQuestionTitle'>English</div>
                                                <div className="sysInput">
                                                    <Form.Item
                                                        name="wpaQuestion2"
                                                        rules={[
                                                            {
                                                                required: true, message: 'English is required.'
                                                            },
                                                            {
                                                                validator: (rule, value) => validateForm(value,"wpaQuestion2")
                                                            },
                                                        ]}
                                                    >
                                                        <Input type="text" maxLength={255} onChange={(e) => questionChange(e.target.value, "wpaQuestion2Tc","wpaQuestion2Sc")} />
                                                    </Form.Item>
                                                </div>
                                            </div>
                                            <div className='wpaQuestionBox'>
                                                <div className='wpaQuestionTitle'>Traditional Chinese</div>
                                                <div className="sysInput">
                                                    <Form.Item
                                                        name="wpaQuestion2Tc"
                                                        rules={[
                                                            {
                                                                required: false,
                                                                validator: (rule, value) => validateForm(value,"wpaQuestion2Tc")
                                                            },
                                                        ]}
                                                    >
                                                        <Input type="text" maxLength={255} onChange={(e) => questionChange(e.target.value, "wpaQuestion2","wpaQuestion2Sc")} />
                                                    </Form.Item>
                                                </div>
                                            </div>
                                            <div className='wpaQuestionBox'>
                                                <div className='wpaQuestionTitle'>Simplified Chinese</div>
                                                <div className="sysInput">
                                                    <Form.Item
                                                        name="wpaQuestion2Sc"
                                                        rules={[
                                                            {
                                                                required: false,
                                                                validator: (rule, value) => validateForm(value,"wpaQuestion2Sc")
                                                            },
                                                        ]}
                                                    >
                                                        <Input type="text" maxLength={255} onChange={(e) => questionChange(e.target.value, "wpaQuestion2","wpaQuestion2Tc")} />
                                                    </Form.Item>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div>
                                            <div className="sysParam  mustFill">{trans.programmeUniqueQuestion3[Config.backLang]}</div>
                                        </div>
                                        <div className='wpaQuestionRow'>
                                            <div className='wpaQuestionBox'>
                                                <div className='wpaQuestionTitle'>English</div>
                                                <div className="sysInput">
                                                    <Form.Item
                                                        name="wpaQuestion3"
                                                        rules={[
                                                            {
                                                                required: true, message: 'English is required.'
                                                            },
                                                            {
                                                                validator: (rule, value) => validateForm(value,"wpaQuestion3")
                                                            },
                                                        ]}
                                                    >
                                                        <Input type="text" maxLength={255} onChange={(e) => questionChange(e.target.value, "wpaQuestion3Tc","wpaQuestion3Sc")} />
                                                    </Form.Item>
                                                </div>
                                            </div>
                                            <div className='wpaQuestionBox'>
                                                <div className='wpaQuestionTitle'>Traditional Chinese</div>
                                                <div className="sysInput">
                                                    <Form.Item
                                                        name="wpaQuestion3Tc"
                                                        rules={[
                                                            {
                                                                required: false,
                                                                validator: (rule, value) => validateForm(value,"wpaQuestion3Tc")
                                                            },
                                                        ]}
                                                    >
                                                        <Input type="text" maxLength={255} onChange={(e) => questionChange(e.target.value, "wpaQuestion3","wpaQuestion3Sc")} />
                                                    </Form.Item>
                                                </div>
                                            </div>
                                            <div className='wpaQuestionBox'>
                                                <div className='wpaQuestionTitle'>Simplified Chinese</div>
                                                <div className="sysInput">
                                                    <Form.Item
                                                        name="wpaQuestion3Sc"
                                                        rules={[
                                                            {
                                                                required: false,
                                                                validator: (rule, value) => validateForm(value,"wpaQuestion3Sc")
                                                            },
                                                        ]}
                                                    >
                                                        <Input type="text" maxLength={255} onChange={(e) => questionChange(e.target.value, "wpaQuestion3","wpaQuestion3Tc")} />
                                                    </Form.Item>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div>
                                            <div className="sysParam  mustFill">{trans.programmeUniqueQuestion4[Config.backLang]}</div>
                                        </div>
                                        <div className='wpaQuestionRow'>
                                            <div className='wpaQuestionBox'>
                                                <div className='wpaQuestionTitle'>English</div>
                                                <div className="sysInput">
                                                    <Form.Item
                                                        name="wpaQuestion4"
                                                        rules={[
                                                            {
                                                                required: true, message: 'English is required.'
                                                            },
                                                            {
                                                                validator: (rule, value) => validateForm(value,"wpaQuestion4")
                                                            },
                                                        ]}
                                                    >
                                                        <Input type="text" maxLength={255} onChange={(e) => questionChange(e.target.value, "wpaQuestion4Tc","wpaQuestion4Sc")} />
                                                    </Form.Item>
                                                </div>
                                            </div>
                                            <div className='wpaQuestionBox'>
                                                <div className='wpaQuestionTitle'>Traditional Chinese</div>
                                                <div className="sysInput">
                                                    <Form.Item
                                                        name="wpaQuestion4Tc"
                                                        rules={[
                                                            {
                                                                required: false,
                                                                validator: (rule, value) => validateForm(value,"wpaQuestion4Tc")
                                                            },
                                                        ]}
                                                    >
                                                        <Input type="text" maxLength={255} onChange={(e) => questionChange(e.target.value, "wpaQuestion4","wpaQuestion4Sc")} />
                                                    </Form.Item>
                                                </div>
                                            </div>
                                            <div className='wpaQuestionBox'>
                                                <div className='wpaQuestionTitle'>Simplified Chinese</div>
                                                <div className="sysInput">
                                                    <Form.Item
                                                        name="wpaQuestion4Sc"
                                                        rules={[
                                                            {
                                                                required: false,
                                                                validator: (rule, value) => validateForm(value,"wpaQuestion4Sc")
                                                            },
                                                        ]}
                                                    >
                                                        <Input type="text" maxLength={255} onChange={(e) => questionChange(e.target.value, "wpaQuestion4","wpaQuestion4Tc")} />
                                                    </Form.Item>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div>
                                            <div className="sysParam  mustFill">{trans.programmeUniqueQuestion5[Config.backLang]}</div>
                                        </div>
                                        <div className='wpaQuestionRow'>
                                            <div className='wpaQuestionBox'>
                                                <div className='wpaQuestionTitle'>English</div>
                                                <div className="sysInput">
                                                    <Form.Item
                                                        name="wpaQuestion5"
                                                        rules={[
                                                            {
                                                                required: true, message: 'English is required.'
                                                            },
                                                            {
                                                                validator: (rule, value) => validateForm(value,"wpaQuestion5")
                                                            },
                                                        ]}
                                                    >
                                                        <Input type="text" maxLength={255} onChange={(e) => questionChange(e.target.value, "wpaQuestion5Tc","wpaQuestion5Sc")} />
                                                    </Form.Item>
                                                </div>
                                            </div>
                                            <div className='wpaQuestionBox'>
                                                <div className='wpaQuestionTitle'>Traditional Chinese</div>
                                                <div className="sysInput">
                                                    <Form.Item
                                                        name="wpaQuestion5Tc"
                                                        rules={[
                                                            {
                                                                required: false,
                                                                validator: (rule, value) => validateForm(value,"wpaQuestion5Tc")
                                                            },
                                                        ]}
                                                    >
                                                        <Input type="text" maxLength={255} onChange={(e) => questionChange(e.target.value, "wpaQuestion5","wpaQuestion5Sc")} />
                                                    </Form.Item>
                                                </div>
                                            </div>
                                            <div className='wpaQuestionBox'>
                                                <div className='wpaQuestionTitle'>Simplified Chinese</div>
                                                <div className="sysInput">
                                                    <Form.Item
                                                        name="wpaQuestion5Sc"
                                                        rules={[
                                                            {
                                                                required: false,
                                                                validator: (rule, value) => validateForm(value,"wpaQuestion5Sc")
                                                            },
                                                        ]}
                                                    >
                                                        <Input type="text" maxLength={255} onChange={(e) => questionChange(e.target.value, "wpaQuestion5","wpaQuestion5Tc")} />
                                                    </Form.Item>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div>
                                            <div className="sysParam  mustFill">{trans.programmeUniqueQuestion6[Config.backLang]}</div>
                                        </div>
                                        <div className='wpaQuestionRow'>
                                            <div className='wpaQuestionBox'>
                                                <div className='wpaQuestionTitle'>English</div>
                                                <div className="sysInput">
                                                    <Form.Item
                                                        name="wpaQuestion6"
                                                        rules={[
                                                            {
                                                                required: true, message: 'English is required.'
                                                            },
                                                            {
                                                                validator: (rule, value) => validateForm(value,"wpaQuestion6")
                                                            },
                                                        ]}
                                                    >
                                                        <Input type="text" maxLength={255} onChange={(e) => questionChange(e.target.value, "wpaQuestion6Tc","wpaQuestion6Sc")} />
                                                    </Form.Item>
                                                </div>
                                            </div>
                                            <div className='wpaQuestionBox'>
                                                <div className='wpaQuestionTitle'>Traditional Chinese</div>
                                                <div className="sysInput">
                                                    <Form.Item
                                                        name="wpaQuestion6Tc"
                                                        rules={[
                                                            {
                                                                required: false,
                                                                validator: (rule, value) => validateForm(value,"wpaQuestion6Tc")
                                                            },
                                                        ]}
                                                    >
                                                        <Input type="text" maxLength={255} onChange={(e) => questionChange(e.target.value, "wpaQuestion6","wpaQuestion6Sc")} />
                                                    </Form.Item>
                                                </div>
                                            </div>
                                            <div className='wpaQuestionBox'>
                                                <div className='wpaQuestionTitle'>Simplified Chinese</div>
                                                <div className="sysInput">
                                                    <Form.Item
                                                        name="wpaQuestion6Sc"
                                                        rules={[
                                                            {
                                                                required: false,
                                                                validator: (rule, value) => validateForm(value,"wpaQuestion6Sc")
                                                            },
                                                        ]}
                                                    >
                                                        <Input type="text" maxLength={255} onChange={(e) => questionChange(e.target.value, "wpaQuestion6","wpaQuestion6Tc")} />
                                                    </Form.Item>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div>
                                            <div className="sysParam  mustFill">{trans.programmeUniqueQuestion7[Config.backLang]}</div>
                                        </div>
                                        <div className='wpaQuestionRow'>
                                            <div className='wpaQuestionBox'>
                                                <div className='wpaQuestionTitle'>English</div>
                                                <div className="sysInput">
                                                    <Form.Item
                                                        name="wpaQuestion7"
                                                        rules={[
                                                            {
                                                                required: true, message: 'English is required.'
                                                            },
                                                            {
                                                                validator: (rule, value) => validateForm(value,"wpaQuestion7")
                                                            },
                                                        ]}
                                                    >
                                                        <Input type="text" maxLength={255} onChange={(e) => questionChange(e.target.value, "wpaQuestion7Tc","wpaQuestion7Sc")} />
                                                    </Form.Item>
                                                </div>
                                            </div>
                                            <div className='wpaQuestionBox'>
                                                <div className='wpaQuestionTitle'>Traditional Chinese</div>
                                                <div className="sysInput">
                                                    <Form.Item
                                                        name="wpaQuestion7Tc"
                                                        rules={[
                                                            {
                                                                required: false,
                                                                validator: (rule, value) => validateForm(value,"wpaQuestion7Tc")
                                                            },
                                                        ]}
                                                    >
                                                        <Input type="text" maxLength={255} onChange={(e) => questionChange(e.target.value, "wpaQuestion7","wpaQuestion7Sc")} />
                                                    </Form.Item>
                                                </div>
                                            </div>
                                            <div className='wpaQuestionBox'>
                                                <div className='wpaQuestionTitle'>Simplified Chinese</div>
                                                <div className="sysInput">
                                                    <Form.Item
                                                        name="wpaQuestion7Sc"
                                                        rules={[
                                                            {
                                                                required: false,
                                                                validator: (rule, value) => validateForm(value,"wpaQuestion7Sc")
                                                            },
                                                        ]}
                                                    >
                                                        <Input type="text" maxLength={255} onChange={(e) => questionChange(e.target.value, "wpaQuestion7","wpaQuestion7Tc")} />
                                                    </Form.Item>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div>
                                            <div className="sysParam  mustFill">{trans.programmeUniqueQuestion8[Config.backLang]}</div>
                                        </div>
                                        <div className='wpaQuestionRow'>
                                            <div className='wpaQuestionBox'>
                                                <div className='wpaQuestionTitle'>English</div>
                                                <div className="sysInput">
                                                    <Form.Item
                                                        name="wpaQuestion8"
                                                        rules={[
                                                            {
                                                                required: true, message: 'English is required.'
                                                            },
                                                            {
                                                                validator: (rule, value) => validateForm(value,"wpaQuestion8")
                                                            },
                                                        ]}
                                                    >
                                                        <Input type="text" maxLength={255} onChange={(e) => questionChange(e.target.value, "wpaQuestion8Tc","wpaQuestion8Sc")} />
                                                    </Form.Item>
                                                </div>
                                            </div>
                                            <div className='wpaQuestionBox'>
                                                <div className='wpaQuestionTitle'>Traditional Chinese</div>
                                                <div className="sysInput">
                                                    <Form.Item
                                                        name="wpaQuestion8Tc"
                                                        rules={[
                                                            {
                                                                required: false,
                                                                validator: (rule, value) => validateForm(value,"wpaQuestion8Tc")
                                                            },
                                                        ]}
                                                    >
                                                        <Input type="text" maxLength={255} onChange={(e) => questionChange(e.target.value, "wpaQuestion8","wpaQuestion8Sc")} />
                                                    </Form.Item>
                                                </div>
                                            </div>
                                            <div className='wpaQuestionBox'>
                                                <div className='wpaQuestionTitle'>Simplified Chinese</div>
                                                <div className="sysInput">
                                                    <Form.Item
                                                        name="wpaQuestion8Sc"
                                                        rules={[
                                                            {
                                                                required: false,
                                                                validator: (rule, value) => validateForm(value,"wpaQuestion8Sc")
                                                            },
                                                        ]}
                                                    >
                                                        <Input type="text" maxLength={255} onChange={(e) => questionChange(e.target.value, "wpaQuestion8","wpaQuestion8Tc")} />
                                                    </Form.Item>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysColMax'>
                                        <div className="sysParam">Section B i Box Content (English)</div>
                                        <div className="sysInputs">
                                            <Form.Item
                                                name="IBoxContent"
                                            >
                                                <TextArea rows={3} placeholder="Section B i Box Content" maxLength={500} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysColMax'>
                                        <div className="sysParam">Section B i Box Content (TC)</div>
                                        <div className="sysInputs">
                                            <Form.Item
                                                name="IBoxContentTC"
                                            >
                                                <TextArea rows={3} placeholder="Section B i Box Content (TC)" maxLength={500} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysColMax'>
                                        <div className="sysParam">Section B i Box Content (SC)</div>
                                        <div className="sysInputs">
                                            <Form.Item
                                                name="IBoxContentSC"
                                            >
                                                <TextArea rows={3} placeholder="Section B i Box Content (SC)" maxLength={500} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className="sysSaveButton">
                                    <Button className="sysBtn btnBlue" type="primary" disabled={isLoad} icon={<CheckCircleOutlined />} htmlType="submit">{trans.save[Config.backLang]}</Button>
                                    <Button className="sysBtn" icon={<CloseCircleOutlined />} onClick={cancel}>{trans.cancel[Config.backLang]}</Button>
                                </div>
                            </Form>
                        </TabPane>


                    </Tabs>
                </Spin>
            </div>
        </div>
    )

}

export default ProgrammeWpaTemplate;